import { useTranslation } from 'react-i18next';
import { ExternalLink } from 'lucide-react';
import type { AppInfo } from '../../types/auth';
import { getAppRedirectUrl } from '../../lib/utils';

interface AppSelectorProps {
  apps: AppInfo[];
  token: string;
  onClose: () => void;
}

export function AppSelector({ apps, token, onClose }: AppSelectorProps) {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4 shadow-2xl">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-gray-900">
            {t('general.appSelectorTitle')}
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-xl">
            &times;
          </button>
        </div>
        <p className="text-gray-600 text-sm mb-6">{t('general.appSelectorDesc')}</p>
        <div className="space-y-3">
          {apps.map((app) => (
            <button
              key={app.appId}
              onClick={() => {
                window.location.href = getAppRedirectUrl(app, token);
              }}
              className="w-full flex items-center gap-3 px-4 py-3 rounded-lg border border-gray-200 hover:border-primary hover:bg-primary/5 transition-colors text-left"
            >
              <ExternalLink className="w-5 h-5 text-primary flex-shrink-0" />
              <span className="font-medium text-gray-800">{app.name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
